export const workTitleEN = 'Work Experience';
export const workTitleES = 'Experiencia Laboral';

export const startupsEN = [
  {
    id: 1,
    src: '/images/startups/yolopido.png',
    alt: 'yolopido-logo',
    data: '2018/02/03 - 2018/06/22 (6 Months).',
    technologies: 'C Sharp, ASP.NET, CSS, JAVASCRIPT.',
    workplace: 'Frontend Developer',
    backgroundImage: '/images/startups/yolopido-background.jpg',
    message: {
      startup: {
        title: 'About Yolopido:',
        info: [
          {
            id: 1,
            paragraph: 'Yolopido is a web portal that helps you improve your experience of ordering food at home, we offer you the opportunity to order and customize orders in your favorite restaurants that have home delivery and additionally we provide easy and safe payment methods.'
          }
        ]
      },
      me: {
        title: 'About my development in Yolopido:',
        expandedInfo: 'Show less',
        expandInfo: 'Show more...',
        info: [
          {
            id: 1,
            paragraph: 'I worked on solving errors, integrating new functions and renewing some obsolete ones thanks to the comments of the users for a Venezuelan startup called Yolopido.'
          },
          {
            id: 2,
            paragraph: 'The knowledge acquired in Yolopido focused on Microsoft technology, such as C #, ASP.net and SQL Server Management Studio 2014 (I acquired basic knowledge), the interactive features of Frontend were handled in principle with JavaScript. Vanila and JQuery were subsequently managed with  React.'
          }
        ],
      }
    }
  },
  {
    id: 2,
    src: '/images/startups/coinsenda.png',
    alt: 'coinsenda-logo',
    data: '2018/07/15 - 2018/09/14 (2 Months).',
    technologies: 'React.js, Redux, React-Router.',
    workplace: 'Frontend Developer',
    backgroundImage: '/images/startups/coinsenda-background.jpg',
    message: {
      startup: {
        title: 'About Coinsenda:',
        info: [
          {
            id: 1,
            paragraph: 'Consenda is a growing startup that allows clients to perform transactions and exchanges of virtual goods (Cryptocurrencies)'
          }
        ]
      },
      me: {
        title: 'About my development in Coinsenda:',
        info: [
          {
            id: 1,
            paragraph: 'I worked developing new features of a Colombian startup called Coinsenda, oriented to the Blockchain area; The most outstanding features implemented are a Referral system and a Home page.'
          }
        ],
      }
    }
  },
  {
    id: 3,
    src: '/images/startups/devoping.png',
    alt: 'devoping-logo',
    data: '2018/10/19 - 2019/01/27 (4 Months).',
    technologies: 'React.js, Next.js, Redux.',
    workplace: 'Frontend Developer',
    backgroundImage: '/images/startups/devoping-background.jpg',
    message: {
      startup: {
        title: 'About Devoping:',
        info: [
          {
            id: 1,
            paragraph: 'Depoving help startups, companies and professionals to transform ideas into innovative digital projects'
          }
        ]
      },
      me: {
        title: 'About my development in Devoping:',
        expandedInfo: 'Show less',
        expandInfo: 'Show more...',
        info: [
          {
            id: 1,
            paragraph: 'I worked on the development of an application called BeMySpeaker that aimed to connect individuals with dominoes in different languages (Freelancers) and users (Clients).'
          },
          {
            id: 2,
            paragraph: 'I Participate as Frontend developer in charge of creating the bases of the project, coordinate and help the rest of Frontend level developers, among the most outstanding developed modules you will find: Authentication system (Register and Log in session), Dashboard, Home page, System  of punctuation (Feedback between users and clients), Publications system (create, delete and / or edit publications), multi-users (Different options depending on the type of user, Clients or Freelancers).'
          }
        ],
      }
    }
  },
  {
    id: 4,
    src: '/images/startups/vascar-solutions.png',
    alt: 'vascar-solutions-logo',
    data: '2019/02/10 - 2019/08/00 (7 Months).',
    technologies: 'React, Redux, React-Router',
    workplace: 'Frontend Developer',
    backgroundImage: '/images/startups/vascar-solutions-background.jpg',
    message: {
      startup: {
        title: 'About Vascar Solutions:',
        expandedInfo: 'Show less',
        expandInfo: 'Show more...',
        info: [
          {
            id: 1,
            paragraph: 'Vascar Solutions is a trusted technology partner for innovators and visionaries. We build custom software products from the ground up with creative collaboration and expertly-executed code. We are also able to provide talented experienced staff of all levels to integrate with clients existing teams.'
          },
          {
            id: 2,
            paragraph: 'We leverage our nearshore model by providing local project managers and senior architects to work with you directly. Our NYC team is personable, great at communication and full of knowledge.'
          },
          {
            id: 3,
            paragraph: 'Our team in South America consists of engineers, designers and managers with a wealth of experience with big brands to incubating startups. Agile collaboration and efficient engineering translates to less waste and lower costs.'
          }
        ]
      },
      me: {
        title: 'About my development in Vascar Solutions:',
        expandedInfo: 'Show less',
        expandInfo: 'Show more...',
        info: [
          {
            id: 1,
            paragraph: 'I worked in the development of multiple projects for a company called Vascar Solutions.'
          },
          {
            id: 2,
            paragraph: 'The most outstanding project where I worked was company whichis in production stage. I developed the graphic interface and part of the functionality, among the most notable modules are; Authentication system, Notifications panel and Statistics panel.'
          }
        ],
      }
    }
  }
];

export const startupsES = [
  {
    id: 1,
    src: '/images/startups/yolopido.png',
    alt: 'yolopido-logo',
    data: '03/02/2018 - 22/06/2018 (6 Meses).',
    technologies: 'C Sharp, ASP.NET, CSS, JAVASCRIPT.',
    workplace: 'Desarollador Frontend',
    backgroundImage: '/images/startups/yolopido-background.jpg',
    message: {
      startup: {
        title: 'Sobre Yolopido:',
        info: [
          {
            id: 1,
            paragraph: 'Es un portal web que viene a ayudarte a mejorar tu experiencia de pedir comida a domicilio, te ofrecemos la oportunidad de ordenar y personalizar los pedidos en tus restaurantes favoritos que posean servicio a domicilio y adicionalmente te brindamos métodos de pago fáciles y seguros.'
          }
        ]
      },
      me: {
        title: 'Sobre mi desarollo en Yolopido:',
        expandedInfo: 'Mostrar menos',
        expandInfo: 'Mostrar mas...',
        info: [
          {
            id: 1,
            paragraph: 'Resolviendo errores, integrando nuevas funciones y renovando algunas obsoletas gracias a los comentarios de los usuarios para una startup Venezolana llamada Yolopido.'
          },
          {
            id: 2,
            paragraph: 'Los conocimientos adquiridos en Yolopido se centraron en la tecnologíade Microsoft, como C #, ASP.net y SQL Server Management Studio 2014(Adquirí conocimientos básicos), las características interactivas deFrontend se manejaron en principio con JavaScript Vanila yJQuery posterior a ello por recomendación propia se manejaron con React.'
          }
        ],
      }
    }
  },
  {
    id: 2,
    src: '/images/startups/coinsenda.png',
    alt: 'coinsenda-logo',
    data: '15/07/2018 - 14/09/2018 (2 Meses).',
    technologies: 'React.js, Redux, React-Router.',
    workplace: 'Desarollador Frontend',
    backgroundImage: '/images/startups/coinsenda-background.jpg',
    message: {
      startup: {
        title: 'Sobre Coinsenda:',
        info: [
          {
            id: 1,
            paragraph: 'Consenda es una startup en crecimiento que permite a los clientes realizar operaciones e intercambios de Bienes Virtuales (Criptomonedas)'
          }
        ]
      },
      me: {
        title: 'Sobre mi desarollo en Coinsenda:',
        info: [
          {
            id: 1,
            paragraph: 'Desarrollo de nuevas características de la plataforma de una startup Colombiana llamada Coinsenda, orientada al área Blockchain, entre ellos lo más destacable es; Sistema de referidos y nueva Home page.'
          }
        ],
      }
    }
  },
  {
    id: 3,
    src: '/images/startups/devoping.png',
    alt: 'devoping-logo',
    data: '19/10/2018 - 27/01/2019 (4 Meses).',
    technologies: 'React.js, Next.js, Redux.',
    workplace: 'Desarollador Frontend',
    backgroundImage: '/images/startups/devoping-background.jpg',
    message: {
      startup: {
        title: 'Sobre Devoping:',
        info: [
          {
            id: 1,
            paragraph: 'Desarrolladora de innovaciones, Devoping ayuda a startups, empresas y profesionales a transformar ideas en proyectos digitales innovadores.'
          }
        ]
      },
      me: {
        title: 'Sobre mi desarollo en Devoping:',
        expandedInfo: 'Mostrar menos',
        expandInfo: 'Mostrar mas...',
        info: [
          {
            id: 1,
            paragraph: 'Desarrollo de una aplicación llamada BeMySpeaker que tenía como objetivo conectar a individuos con dominós en distintos idiomas (Freelancers) y usuarios (Clientes).'
          },
          {
            id: 2,
            paragraph: 'Participe como desarrollador Frontend encargado de crear las bases del proyecto, coordinar y ayudar al resto de desarrolladores a nivel de Frontend, entre los módulos desarrollados más destacados se encuentra: Sistema de autenticación (Registrar e Iniciar de sesión), Dashboard, Home page, Sistema de puntuación (Feedback entre usuarios y clientes), Sistema de publicaciones (Crear, eliminar y/o editar publicaciones), multi-users (Distintas opciones dependiendo el tipo de usuario; Clientes o Freelancers).'
          }
        ],
      }
    }
  },
  {
    id: 4,
    src: '/images/startups/vascar-solutions.png',
    alt: 'vascar-solutions-logo',
    data: '2019/02/10 - 2019/08/00 (7 Months).',
    technologies: 'React, Redux, React-Router',
    workplace: 'Desarollador Frontend',
    backgroundImage: '/images/startups/vascar-solutions-background.jpg',
    message: {
      startup: {
        title: 'Sobre Vascar Solutions:',
        expandedInfo: 'Mostrar menos',
        expandInfo: 'Mostrar mas...',
        info: [
          {
            id: 1,
            paragraph: 'Vascar Solutions es un socio tecnológico de confianza para innovadores y visionarios. Construimos productos de software personalizados desde el principio con colaboración creativa y código ejecutado por expertos. También podemos proporcionar personal experimentado y talentoso de todos los niveles para integrarse con los equipos existentes de los clientes.'
          },
          {
            id: 2,
            paragraph: 'Aprovechamos nuestro modelo nearshore proporcionando gerentes de proyectos locales y arquitectos de alto nivel para que trabajen con usted directamente. Nuestro equipo de Nueva York es agradable, excelente para la comunicación y lleno de conocimiento.'
          },
          {
            id: 3,  
            paragraph: 'Nuestro equipo en América del Sur está formado por ingenieros, diseñadores y gerentes con una gran experiencia con grandes marcas para incubar startups. La colaboración ágil y la ingeniería eficiente se traducen en menos desperdicio y menores costos.'
          }
        ]
      },
      me: {
        title: 'Sobre mi desarollo en Vascar Solutions:',
        info: [
          {
            id: 1,
            paragraph: 'Desarrollo de múltiples proyectos, uno de los proyectos más destacado desarolladses Compa el cual se encuentra actualmente en fase de producción, fui el encargado de crear toda la interfaz gráfica y gran parte de la funcionabilidad, entre sus módulos más destacables se encuentra; Sistema de autenticación, Panel de notificaciones y Panel de estadísticas (Por temas de confidencialidad no puedo detallar su objetivo o mi desarrollo en el proyecto).'
          }
        ],
      }
    }
  }
];
